<template>
<div class="rounded p-4" style="background:#fdf6ec ">
    <!--<div class="alert alert-warning text-center">¡FULLDAY SOLO EN BOLETERIA DE PISCINA!</div>-->
    <h3 style="color:#1a4a84; font-size: 18px" class="border-bottom">{{title}}</h3>
    <div class="mb-4">
        <!--<img :src="getClubParque.imagenUrl" class="w-100" style="height: 150px;"/>-->
        <h4 class="m-0" style="color:#757575; font-size: 15px;">{{getClubParque.name}}</h4>
        <p class="m-0">{{getClubParque.address}}</p>
    </div>

    <table class="table">
      <tbody>
        <tr>
          <td><b style="color:#1a4a84">Fecha seleccionada</b></td>
          <td>{{getDateVisit}}</td>
        </tr>
        <tr>
          <td><b style="color:#1a4a84">Productos seleccionados</b></td>
          <td>{{doneTodos.length}}</td>
        </tr>
        <tr>
          <td><b style="color:#1a4a84">Importe a pagar</b></td>
          <td><h5 class="text-primary">S/ {{totalPagar}}</h5></td>
        </tr>
      </tbody>
    </table>

    <b v-if="doneTodos.length>0">Detalle</b>

    <table v-if="doneTodos.length>0" class="table mt-4">
        <thead>
            <tr>
                <th scope="col">Item</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Importe</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in doneTodos" :key="index">
                <td style="line-height:1.2">{{item.descripcionProducto}}</td>
                <td>{{item.cantidad}}</td>
                <td>S/ {{item.total.toFixed(2)}}</td>
            </tr>
        </tbody>
    </table>

    <el-alert v-else title="Su carrito se encuentra vacío" type="warning"></el-alert>

    <!--<el-alert title="*Monto mínimo de compra: S/10.00" type="warning" :closable="false" class="mt-4"></el-alert>-->

</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
      title: {
        type: String,
        required: true,
        default: 'Resumen de compra'
      }

    },
    computed: {
      ...mapGetters(['doneTodos', 'totalPagar', 'getClubParque', 'getDateVisit'])

    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/entradas/Resumen.vue